import './PilotOverview.css'
import gradeIcon from "asset/image/pilot/icon-grade.png";
import statsIcon from "asset/image/pilot/icon-stats.png";
import skillIcon from "asset/image/pilot/icon-skill.png";
import specialBoxIcon from "asset/image/pilot/icon-special-box.png";
import extraPowerIcon from "asset/image/pilot/icon-extra-power.png";
import breedingIcon from "asset/image/pilot/icon-breeding.png";
import particles2 from "asset/image/pilot/particles2.png";
import {useTranslation} from "react-i18next";

const PilotOverview = () => {

    const { t, i18n } = useTranslation();

    return (
        <div className={"overview"}>
            <div className="nft">
                <div className="tab-intro">

                    <div className={"tab-text"}>
                        <div className={"tab-title"}>
                            {
                                t("PILOT_OVERVIEW")
                            }

                        </div>
                        <div className={"tab-desc"}>
                            {
                                t("PILOT_OVERVIEW_DESC")
                            }

                        </div>
                    </div>
                </div>

                <div className="nft-container">
                    <div className="nft-item">
                        <div className="nft-img">
                            <img src={gradeIcon} alt=""/>
                        </div>

                        <div className="nft-text">
                            <div className="nft-title">
                                GRADE
                            </div>

                            <div className="nft-desc">
                                {
                                    t("PILOT_GRADE_DESC")
                                }

                            </div>
                        </div>

                    </div>

                    <div className="nft-item">
                        <div className="nft-img">
                            <img src={statsIcon} alt=""/>
                        </div>

                        <div className="nft-text">
                            <div className="nft-title">
                                STATS
                            </div>

                            <div className="nft-desc">
                                {
                                    t("PILOT_STATS_DESC")
                                }

                            </div>
                        </div>

                    </div>


                    <div className="nft-item">
                        <div className="nft-img">
                            <img src={skillIcon} alt=""/>
                        </div>

                        <div className="nft-text">
                            <div className="nft-title">
                                SKILL
                            </div>

                            <div className="nft-desc">
                                {
                                    t("PILOT_SKILL_DESC")
                                }
                            </div>
                        </div>

                    </div>

                </div>

                <div className="bottom-glow"/>


            </div>

            <div className="separate-line"/>

            {/*<div className="skill">*/}
            
            {/*    <div className="tab-intro">*/}
            
            {/*        <div className={"tab-text"}>*/}
            {/*            /!*<div className={"tab-title"}>*!/*/}
            {/*            /!*    {*!/*/}
            {/*            /!*        t("PILOT_NFT_SKILL")*!/*/}
            {/*            /!*    }*!/*/}
            {/*            /!*</div>*!/*/}
            {/*            <div className={"tab-desc"}>*/}
            {/*                {*/}
            {/*                    t("PILOT_NFT_SKILL_DESC")*/}
            {/*                }*/}
            
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            
            {/*    /!*<div className="skill-container">*!/*/}
            {/*    /!*    <div className="skill-item">*!/*/}
            {/*    /!*        <div className="skill-img">*!/*/}
            {/*    /!*            <img src={specialBoxIcon} alt=""/>*!/*/}
            {/*    /!*        </div>*!/*/}
            
            {/*    /!*        <div className="skill-text">*!/*/}
            {/*    /!*            <div className="skill-title">*!/*/}
            {/*    /!*                {*!/*/}
            {/*    /!*                    t("PILOT_SPECIAL_BOX_EFFECT")*!/*/}
            {/*    /!*                }*!/*/}
            {/*    /!*            </div>*!/*/}
            {/*    /!*        </div>*!/*/}
            {/*    /!*    </div>*!/*/}
            
            {/*    /!*    <div className="skill-item">*!/*/}
            {/*    /!*        <div className="skill-img">*!/*/}
            {/*    /!*            <img src={extraPowerIcon} alt=""/>*!/*/}
            {/*    /!*        </div>*!/*/}
            
            {/*    /!*        <div className="skill-text">*!/*/}
            {/*    /!*            <div className="skill-title">*!/*/}
            {/*    /!*                {*!/*/}
            {/*    /!*                    t("PILOT_EXTRA_POWER_EFFECT")*!/*/}
            {/*    /!*                }*!/*/}
            
            {/*    /!*            </div>*!/*/}
            {/*    /!*        </div>*!/*/}
            {/*    /!*    </div>*!/*/}
            
            {/*    /!*    <div className="skill-item">*!/*/}
            {/*    /!*        <div className="skill-img">*!/*/}
            {/*    /!*            <img src={breedingIcon} alt=""/>*!/*/}
            {/*    /!*        </div>*!/*/}
            
            {/*    /!*        <div className="skill-text">*!/*/}
            {/*    /!*            <div className="skill-title">*!/*/}
            {/*    /!*                {*!/*/}
            {/*    /!*                    t("PILOT_BREEDING_EFFECT")*!/*/}
            {/*    /!*                }*!/*/}
            {/*    /!*            </div>*!/*/}
            {/*    /!*        </div>*!/*/}
            {/*    /!*    </div>*!/*/}
            
            {/*    /!*</div>*!/*/}
            
            {/*    <div className="bottom-particles">*/}
            {/*        <img src={particles2} alt=""/>*/}
            {/*    </div>*/}
            
            {/*    <div className={"coming-soon"}>*/}
            
            {/*        <div className={"bottom-text"}>*/}
            {/*            {*/}
            {/*                t("PILOT_COMING_SOON")*/}
            {/*            }*/}
            {/*        </div>*/}
            
            {/*        <div className="bottom-glow-container">*/}
            {/*            <div className="glow1"/>*/}
            {/*            <div className="glow2"/>*/}
            {/*            <div className="glow3"/>*/}
            {/*            <div className="glow4"/>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            
            
            {/*</div>*/}
        </div>
    )
}

export default PilotOverview;